var _path, _path2, _path3, _path4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndividualIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.165 13.334c-1.012 0-1.865-.851-1.478-1.786a4.667 4.667 0 0 1 8.623 0c.387.935-.465 1.786-1.477 1.786H7.165Z",
    fill: "#00C27C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.224 11.333a3.556 3.556 0 1 1-7.11 0 3.556 3.556 0 0 1 7.11 0Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.668 8.222a3.111 3.111 0 1 0 0 6.222 3.111 3.111 0 0 0 0-6.222Zm-4 3.111a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    fill: "#00C27C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m4.667 13.11 2.37-1.777-2.37-1.778v1.185h-2.37v1.185h2.37v1.185Z",
    fill: "#00C27C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.001,
    cy: 4.666,
    r: 3.333,
    fill: "#00C27C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualIcon);
export default __webpack_public_path__ + "static/media/individual-icon.c2dca5ddaa3ab413275c0d8a9d93cad4.svg";
export { ForwardRef as ReactComponent };